import { useTranslation } from 'react-i18next';

/**
 * i18n_ — skip link for keyboard/screen-reader users.
 *
 * Rendered as the first focusable element in AppLayout. Visually hidden
 * until focused, at which point it reveals a high-contrast button that
 * jumps past the sidebar straight to the main content region. Required
 * for WCAG 2.1 success criterion 2.4.1 ("Bypass Blocks").
 */
export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[999] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-brand-600 focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2"
    >
      {t('i18n_a11y.skip_to_main', { defaultValue: 'Skip to main content' })}
    </a>
  );
}
